import {Component, ViewChild} from '@angular/core';
//import {Http} from '@angular/http';

import * as moment from 'moment';
import {LeadsService} from "../../../models/leads/leads.service";
import {LeadsModel} from "../../../models/leads/leads.model";
//import {BadgesService} from "../../../models/badges/badges.service";
//import {BadgesHelper} from "../../../services/BadgesHelper";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {dateTimeHelper} from "../../../helpers/date";
import { Router } from '@angular/router';

import {PermissionsService} from "../../../services/permissions/permissions.service";

@Component({
    selector: 'lead-global-search',
    templateUrl: 'global-search.template.html',
    styleUrls: ['global-search.component.css']
})
export class LeadGlobalSearchComponent
{
    model: any = false;

    searchError: any = false;

    searchStr: any;

    isLoading: any = false;

    message: any = false;

    constructor(
        private leadsService: LeadsService,
        //public badgesService: BadgesService,
        //public badgesHelper: BadgesHelper,
        public toasterService: ToasterService,
        private router: Router,
        public permission: PermissionsService
    ) {

    }

    ngOnInit() {
        this.searchLoad();
    }

    searchLoad() {
        this.load({q: this.searchStr});
    }

    private _load_once: any = {};
    load(filter: any) {

        this.model = false;
        this._load_once = {};
        var _local_once = this._load_once;

        try {
            this.message = false;
            if (filter.q.trim().length <= 0) throw "x";
            //this.isLoading = true;
        } catch (e) {
            this.isLoading = false;
            return;
        }

        setTimeout(() => {
            if (this._load_once !== _local_once) return;

            this.isLoading = true;
            this.leadsService.globalSearch(filter)
                .subscribe(
                    (res) => {
                        if (this._load_once !== _local_once) return;
                        this.isLoading = false;
                        this.message = false;
                        this.model = res.data;
                    },
                    (error) => {
                        if (this._load_once !== _local_once) return;

                        this.message = false;
                        try {
                            if (error.status > 499.9 && error.status < 599.9) {
                                setTimeout(() => {
                                    this.searchLoad();
                                }, 500);
                                return;
                            }

                            this.isLoading = false;

                            if (error.status != 400) return;

                            let errorData = JSON.parse(error._body);
                            let errors: any = {};
                            for (var err of errorData.errors) {
                                for (var i in err) {
                                    if (! err.hasOwnProperty(i)) continue;
                                    errors[i] = err[i];
                                }
                            }
                            this.message = errors['message'];
                        } catch (e) {
                        }
                    });
        }, 400);
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

    gotoEntity(entity: any) {
        if (entity.hidden) return;
        try {
            this.router.navigateByUrl(entity.url);
        } catch (e) {
        }
    }

    ////// SOFT REMOVE LEAD

    public leadId: any;

    get canTrashLead() {
        return this.permission.can('leads.update');
    }

    trashLead(entry) {
        if (! entry || ! entry.id) return;
        this.leadId = entry.id;
        if (! this.canTrashLead || this.trashInProcess || entry.type != 'Lead' || entry.hidden) return;
        this.applyTrashClient()
    }

    public trashInProcess = false;

    applyTrashClient() {
        if (! this.canTrashLead || this.trashInProcess) return;
        this.trashInProcess = true;
        this.leadsService.setStatus(this.leadId, {status: 13, reason: 0})
            .map(res => res.json())
            .subscribe(
                (res) => {
                    for (var entry of this.model) {
                        if (entry.type != 'Lead' || entry.id != this.leadId) continue;
                        entry.hidden = true;
                        entry.schedule = null;
                        entry.status = 'Trash';
                    }
                    this.trashInProcess = false;
                    let message = res.data.message ? res.data.message : 'Marked as deleted';
                    this.toasterService.pop('success', 'Success', message);
                    //this.dataTable.refresh();
                },
                (error) => {
                    this.trashInProcess = false;
                    this.toasterService.pop('error', 'Error', 'Lead update error. Try again');
                }
            );
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/global-search/global-search.component.ts